import React from "react";

const RSVPSection = ({
  invitation,
  fontStyleMap,
  slug,
  isOwner,
  theme,
  InvitationRSVPForm,
}) => {
  return (
    <section className="fw-section fw-rsvp">
      <div className="fw-rsvp-inner">
        <h2
          className="fw-section-title"
          style={{ ...(fontStyleMap.subtitle || {}) }}
        >
          Потврди доаѓање
        </h2>
        <p
          className="fw-rsvp-subtitle"
          style={{ ...(fontStyleMap.body || {}) }}
        >
          Почитувани гости, потврдете го вашето присуство најдоцна до{" "}
          {invitation?.rsvp_deadline || "датумот наведен во поканата"}.
        </p>
        <InvitationRSVPForm
          slug={slug}
          defaultName={null}
          defaultGuestId={null}
          disabled={isOwner}
          primaryColor={theme.primary}
          accentColor={theme.secondary}
          hideHeading
          fontStyles={fontStyleMap}
          disabledReason={
            isOwner
              ? "Ова е вашата покана. RSVP е наменет за гостите."
              : undefined
          }
        />
      </div>
    </section>
  );
};

export default RSVPSection;

